import EasyModeUploadListRow from './EasyModeUploadListRow';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import {
  uploadListBodyClasses,
  uploadListClasses,
  uploadListHeaderClasses
} from './easyModeClasses';

const EasyModeUploadList = ({ rows, headerLabel, completedCount, totalCount, onRetry, onRemove }) => (
  <div className={uploadListClasses} data-tour={TOUR_TARGETS.EASY_MODE_UPLOAD_LIST}>
    <div className={uploadListHeaderClasses}>
      <span>{headerLabel}</span>
      <span>{`${completedCount}/${totalCount}`}</span>
    </div>
    {/* scrolls past its max height so sixty files cannot push the footer off screen */}
    <div className={uploadListBodyClasses}>
      {rows.map((row) => (
        <EasyModeUploadListRow key={row.id} row={row} onRetry={onRetry} onRemove={onRemove} />
      ))}
    </div>
  </div>
);

export default EasyModeUploadList;
